import { FC, memo } from "react";
import clsx from "classnames";
import { Game } from "@onmo/graphql/graphql";
import { useTranslation } from "react-i18next";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { isLeavingSoonGame, isNewGame } from "../../../models/game";
import { useStyles } from "./GameStatusTag.style";

interface IGameStatusTagProps {
  game?: Game;
  /** Narrower card columns; drops the label a size on mobile so it fits. */
  isCompact?: boolean;
  className?: string;
}

const GameStatusTagComponent: FC<IGameStatusTagProps> = ({
  game,
  isCompact,
  className,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const label = isLeavingSoonGame(game)
    ? t("GameCard_LEAVING SOON")
    : isNewGame(game)
    ? t("GameCard_NEW")
    : "";

  if (!label) return null;

  return (
    <Typography
      variant={TypographyVariant.HeadingH4Bold}
      className={clsx(classes.tag, isCompact && classes.compact, className)}
    >
      {label}
    </Typography>
  );
};

export const GameStatusTag = memo(GameStatusTagComponent);
